import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import './AdminLayout.css';

// 관리자 화면 공통 틀. 상단 바, 왼쪽 메뉴, 본문 영역으로 나눈다.
export default function AdminLayout() {
    return (
        <div className="admin-layout">
            <header className="admin-header">
                <span className="admin-header-title">GARAM MIND ADMIN</span>
            </header>
            <div className="admin-body">
                <AdminSidebar />
                <main className="admin-content">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
